import { ReactChild, ReactNode } from 'react';
import { IconName } from '@optimus-web/icons';

export enum AlertContainerPosition {
    Center = 'center',
    TopRight = 'topRight',
}

export interface AlertTransitionGroupProps {
    desktopOffset?: number;
    mobileOffset?: number;
    position?: AlertContainerPosition;
}

export interface AlertContainerProps extends AlertTransitionGroupProps {
    alerts: Array<AlertProps>;
    closeButtonLabel: ReactChild;
    appbarHeight?: {
        desktop: number;
        mobile: number;
    };
}

export enum AlertVariant {
    Error = 'error',
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
}

interface WithAlertTitle {
    title: ReactNode;
    description?: ReactNode;
}

interface WithAlertDescription {
    title?: ReactNode;
    description: ReactNode;
}

interface AlertPropsBase {
    id: string;
    action?:
        | {
              text: ReactNode;
              onClick: () => void;
          }
        | ReactNode;
    onClose: () => void;
    onClick?: () => void;
    closeTimeout?: number;
}

export type AlertProps = AlertPropsBase &
    (WithAlertDescription | WithAlertTitle) &
    ({ variant: Extract<AlertVariant, 'info'>; icon?: IconName } | { variant: AlertVariant; icon?: never });

export type AlertItemProps = AlertProps & {
    closeButtonLabel: ReactChild;
};
